<template>
	<div id="companybusiness"></div>
</template>

<script>
	import utils from "@/common/utils.js";
	let oldData = [];
	export default {
		props: {
			info: {
				type: Array,
				default () {
					return [];
				}
			}
		},
		watch: {
			info: {
				handler(val) {
					if (val && val.length) {
						oldData = val;
						this.options.xAxis.data = val.map(item => item.LEVEL3);
						this.options.series[0].data = val.map(item => this.fixedVal(item.Items.Money));
						this.options.series[1].data = val.map(item => item.Items.Quantity);
					} else {
						oldData = val;
						this.options.xAxis.data = [];
						this.options.series[0].data = [];
						this.options.series[1].data = [];
					}
					setTimeout(() => {
						this.myChart.clear();
						this.myChart.setOption(this.options);
					}, 200)
				},
				deep: true,
				immediate: true
			}
		},
		data() {
			return {
				myChart: null,
				options: {
					title: [{
						text: '金额：万元',
						left: '4%',
						top: '2%',
						textStyle: {
							color: '#1D2129',
							fontSize: 12,
							fontWeight: 'normal'
						}
					}, {
						text: '数量：个',
						right: '4%',
						top: '2%',
						textStyle: {
							color: '#1D2129',
							fontSize: 12,
							fontWeight: 'normal'
						}
					}],
					tooltip: {
						trigger: 'axis',
						confine: true,
						hideDelay: 3000,
						formatter(params) {
							let itemStr = ``;
							params.forEach((item, index) => {
								let it = oldData[item.dataIndex].Items[!index ? 'MoneyRatio' : 'QuantityRatio'];
								itemStr = itemStr +
									`<div style="display:flex;align-items: center;" >${item.marker}
									<div style="font-size:14px;font-weight:400;margin:0px 20px 0px 8px;">${item.seriesName} / 占比</div>
									<div style="font-size:14px;font-weight:500;">
										${item.data} / ${it?it:'-'}%
									</div>
								</div>`
							})
							//${!index?'万':'个'}
							let viewStr = `<div><div>${params[0].name}</div>${itemStr}</div>`;
							return viewStr;
						}
					},
					toolbox: {
						show: true,
						top: 7,
						right: 150,
						feature: {
							saveAsImage: {
								icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA2ZJREFUWEfFl09oE0EUh783m4oHBRGFHnqImMTqSUFBUVAPgj0IHhS8iIoetKS1gqIHxYBeRMXWhFKxoAfBgwcLIgge9KAgWLAH0ZpY7EGxoIJgD7HZ3ZHdTbabv91ognNakpn3++bNe2/eCP95SJV+9PBiFi1dg82yptm09YWp4Y/NrCsHSCQvAudAFjdjJDDXRBubyA1OuL+t612CabxBk6fwaxPTd/OVducBEskUiAPwL2MWy9rge6H7eBS745NrUBVWMTkyXRvAJVXf3J1rHiP6NMqsol2QTKnvvBue9eeFBliT3IiW195CvZZsZnJBsTATQgPEkjtQ8qyRq8Lozc9JRSBl8l8A4snLiJzF5gyRwlhZDJgde1HcQOsT5DIjDrAXhK30QKJ/FPRR7zQZRBio+obrZNOn2wPgpd4TYGudY3tJxNpdCtbWe2A+/2tBlIm3xwOlbVd7whM3VRe2zPIx/bm9ACVPFIwRRJtE7CS/6cQw3gM/yaZXth+gMgiCwZ5Nu8ffnhioVzT+GsA5z4JxFmEzWp7TYQ6VldywVeqvAKK9nSwyHgKbAzrjzFl7mB6eqdZORUj8uAH6mPefGiS7/IJbGZsGiPV1oXgKdBeFnNTaXfz+jCU9TN18W1aC4z/uI+yrABtHFfZjRqJ+yV8wBhLJbnDvh07ARPQRPmTukeg/APoO4PQMs1iyn6mbTyAVISgu3MLWeUROFivhT5SMorVbAWkIYKsucN2+whVBHySbGfN3lTi5DewHPhwygNY7/J1rPUQu45XgRHIviANc3mHVBXAuCpGrwBJPXPWQHXpRddare2MYxqPA8XhTguKlRd0DUWzLAd7o26kLMK80A3pnw94gOrCMDmsMYbsfFxFrbe0McYLz+wiId1EtADCJZe0J12C6hkdBDhVdMMGc3VMzQ0JlATLBnFnbQKN8j/edR7jkewK9q8p7oQAsKx5u5zVoghmiuUwufaFsViiAOt1r2GKH118ewuZK6cbz19YFiPeuR4w3XhRbG8gNe319q0esbx8KJxsqgtB7DX0t5uorHPdpJwVbOESvQOQaEAVekU1vcawHHib9x0DfbqFkPVMmqJ2l2lLxNOs/gNaXEGJtAhkHdSpY2Kofp46yc/3atlOGWzfy+ZnGb8PWSTVl6Q8eGbAwgbTYagAAAABJRU5ErkJggg==',
								name: '公司商业销售汇总',
								show: true
							}
						}
					},
					dataZoom: [{
						type: 'slider',
						start: 0,
						end: 35,
						moveHandleSize: 10,
						fillerColor: 'transparent',
						brushSelect: false,
					}],
					grid: {
						left: '8%',
						right: '8%',
						bottom: '25%'
					},
					legend: {
						itemWidth: 35,
						itemHeight: 18,
						data: ['金额', '数量'],
						right: '45%',
						top: '2%'
					},
					xAxis: {
						type: 'category',
						data: [],
						axisPointer: {
							type: 'shadow'
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							rotate: 30,
							fontSize: 12,
							color: '#1D2129'
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#E5E6EB',
								type: [5, 10]
							}
						},
						splitLine: {
							show: false
						},
						splitArea: {
							show: false
						}
					},
					yAxis: [{
							type: 'value',
							axisLabel: {
								show: true,
								//rotate: 45,
								fontSize: 12,
								color: '#01080F',
							},
							axisLine: {
								show: true,
								lineStyle: {
									color: '#E5E6EB',
									type: [5, 10]
								}
							},
							splitLine: {
								show: true,
								lineStyle: {
									color: '#E5E6EB',
									type: [5, 10]
								}
							}
						},
						{
							type: 'value',
							axisLabel: {
								show: true,
								//rotate: 45,
								fontSize: 12,
								color: '#01080F'
							},
							axisLine: {
								show: true,
								lineStyle: {
									color: '#E5E6EB',
									type: [5, 10]
								}
							},
							splitLine: {
								show: false
							}
						}
					],
					series: [{
							name: '金额',
							type: 'bar',
							itemStyle: {
								color: '#00266D',
							},
							barMaxWidth: 36,
							// tooltip: {
							// 	valueFormatter: function(value, t) {
							// 		//console.log(value, t)
							// 		return value + '万元';
							// 	}
							// },
							data: []
						},
						{
							name: '数量',
							type: 'line',
							lineStyle: {
								color: 'transparent'
							},
							symbol: 'triangle',
							symbolSize: 10,
							yAxisIndex: 1,
							itemStyle: {
								color: '#FF0000'
							},
							// tooltip: {
							// 	valueFormatter: function(value) {
							// 		return value + '个';
							// 	}
							// },
							data: []
						}
					]
				}
			}
		},
		mounted() {
			this.init();
		},
		methods: {
			init() {
				let _this = this;
				this.myChart = this.$MyEcharts.init(document.getElementById('companybusiness'));
				this.myChart.clear();
				this.myChart.setOption(this.options);
				window.addEventListener("resize", function() {
					_this.myChart.resize();
				});
			},
			fixedVal(val, num = 1) {
				return (val / 10000).toFixed(num);
			}
		}
	}
</script>

<style lang="less">
	#companybusiness {
		height: 420px;
		padding: 16px;
	}
</style>